import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {MunshiMenu} from "../components/Menu";
import {Button} from 'primereact/button';
import {axiosInstance} from "../utilities/AxiosConfig";
import {DataTable} from 'primereact/datatable';
import {ToastContainer} from 'react-toastify';
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {RadioButton} from "primereact/radiobutton";
import {Column} from "primereact/column";
import {Sidebar} from "primereact/sidebar";
import {ViewImages} from "../components/Image/ImageUtils";
import Cookies from "js-cookie";
import {MonthSelect} from "../components/Select/MonthSelect";

import {useMediaQuery} from "react-responsive";
import {InventoryPrint} from "../print/InventoryPrint";

import {PNLPrint} from "../print/PNLPrint";
import {BugPrint} from "../print/BugPrint";

import {useReactToPrint} from "react-to-print";
import {BalanceSheetTemplate} from "../components/BalanceSheet/BalanceSheetTemplate";
import '../index.css'

import {DepartmentSelect} from "../components/Select/DepartmentSelect";
import {FloatLabel} from "primereact/floatlabel";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";

import {Auths} from "../utilities/getAuthDep";

import {Card} from "primereact/card";
import {numberFromFormatted} from "../utilities/NumberFormatter";

export function SummeryAccount({handle}) {
    const {loading, setLoading} = useSpinner();
    const [action, setAction] = useState("");
    const [projectValue, setProjectValue] = useState("");
    const [proceed, setProceed] = useState(false);

    const [inventory, setInventory] = useState([]);
    const [showInventory, setShowInventory] = useState(false);
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    const [selectedMonth, setSelectedMonth] = useState({id: 1, month: "January"});
    const [department, setDepartment] = useState({id: 1, name: "ALL"});
    const [item, setItem] = useState(null);
    const isDesktop = useMediaQuery({query: '(min-width: 800px)'})
    const [printBalanceSheet, setPrintBalanceSheet] = useState(false);
    const [projectName, setProjectName] = useState("");
    const [balanceSheet, setBalanceSheet] = useState([]);
    const [projectYear, setProjectYear] = useState(0);
    const [companyName, setCompanyName] = useState("");
    const [departmentList, setDepartmentList] = useState([]);

    const [debugReport, setDebugReport] = useState([]);
    const [pr, setPr] = useState([]);
    const printRef = useRef(null);

    const printReport = useReactToPrint({
        contentRef: printRef,
        documentTitle: `BalanceSheet-${selectedMonth.month}-${department?.name || "ALL"}`,
        pageStyle: `
        @page {
            size: A4 landscape;
            margin: 10mm;
        }

        @media print {
            html, body {
                width: 100%;
                margin: 0 !important;
                padding: 0 !important;
                background: #ffffff !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            body {
                font-family: Arial, Helvetica, sans-serif;
                font-size: 10px;
                color: #000;
            }

            .p-card,
            .p-component,
            .p-datatable,
            .p-datatable-wrapper,
            .p-datatable-table {
                width: 100% !important;
                max-width: 100% !important;
                overflow: visible !important;
                box-shadow: none !important;
            }

            .p-card {
                border: 1px solid #d9d9d9 !important;
            }

            .p-card .p-card-body,
            .p-card .p-card-content {
                padding: 0.5rem !important;
            }

            .p-datatable-table {
                table-layout: fixed !important;
                border-collapse: collapse !important;
            }

            .p-datatable-thead > tr > th,
            .p-datatable-tbody > tr > td {
                padding: 4px 6px !important;
                font-size: 9px !important;
                line-height: 1.2 !important;
                word-break: break-word !important;
                white-space: normal !important;
                border: 1px solid #cfcfcf !important;
            }

            .p-datatable-thead > tr > th {
                background: #f3f4f6 !important;
                font-weight: 700 !important;
                text-align: center !important;
            }

            h2, h3 {
                margin: 0 0 6px 0 !important;
            }

            .text-lg {
                font-size: 12px !important;
            }

            .text-sm,
            small {
                font-size: 9px !important;
            }

            button {
                display: none !important;
            }

            .p-datatable-wrapper {
                overflow: visible !important;
            }
        }
    `
    });
    useEffect(() => {
            setPr([])
            setBalanceSheet([])
        }, [selectedMonth, setSelectedMonth, department, setDepartment]
    )
    //login Level
    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [depRes, bioRes] = await Promise.all([
                    axiosInstance.get('department'),
                    axiosInstance.get('biodata/'),
                ]);
                setProjectYear(bioRes.data.accountYear + 1);
                setCompanyName(bioRes.data.name);
                setDepartmentList(depRes.data);
            } catch (error) {
                notify(error.message, "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        setLoading(true)

        setUser(Cookies.get('user') || "Zubair");
        setDatabase(Cookies.get('database') || "Test");
        setLoading(false)
    }, [])
    //loading

    //Load Customer

    const handlePrintOptions = () => {
        switch (action) {
            case "BalanceSheet": {
                setPrintBalanceSheet(true)
                break;
            }
            case "Profit&Loss": {
                PNLPrint(pr, companyName, selectedMonth.month, projectYear)
                break;
            }
            case "Debug": {
                BugPrint(debugReport, companyName, selectedMonth.month, projectYear)
                break;
            }

            default: {

            }
        }
    }

    const loadInventory = (id) => {
        if (Number(id) > 0) {
            setLoading(true)
            axiosInstance.get(`/inventory/id/${id}`).then((response) => {
                if (response.data) {
                    setInventory(response.data)
                    setShowInventory(true)
                } else {
                    notify("No Inventory Found", "error")
                }
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                () => {
                    setLoading(false)
                }
            )

        }
    }
    const resetPage = useCallback(() => {
        setDebugReport([])
        setProjectName("")
        setProjectYear(projectYear + 1)
        setLoading(false)

        setInventory([])
        setShowInventory(false)
        setProceed(false)
        setBalanceSheet([])
        setPr([])


    })
    const applyAction = () => {
        resetPage()
        setShowInventory(false)
        setLoading(true)
        switch (action) {
            case "BalanceSheet": {
                axiosInstance.get(`/account/balanceSheet/month/${selectedMonth.id}&${department.id}`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setBalanceSheet(response.data)
                    } else {
                        notify("No BalanceSheet Not Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)

                    }
                )
                break;
            }
            case "Profit&Loss": {
                axiosInstance.get(`/account/pnl/month/${selectedMonth.id}&${department.id}`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setPr(response.data.filter((b) => b.profit !== 0))
                    } else {
                        notify("No Data Found", "error")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                    }
                )

                break;
            }

            case "Closing": {
                axiosInstance.get(`/account/project/${projectName}&${projectYear}`).then((response) => {
                    console.log(response.data)
                    axiosInstance.get(`/account/add/project/${projectName}&${projectValue}`).then((response) => {
                        notify(response.data.message, "success")
                    })

                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)
                        setProceed(true)
                    }
                )
                break;
            }
            case "CleanAccount": {
                axiosInstance.get("/account/clean/all/").then((response) => {

                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)

                    }
                )
                break;
            }
            case "Debug": {

                axiosInstance.get(`/account/check/accounts/`).then((response) => {
                    if (response.data && response.data.length > 0) {
                        setDebugReport(response.data)

                    } else {
                        notify("No Error Found", "success")
                    }
                }).catch((error) => {
                    notify(error.message, "error")
                }).finally(
                    () => {
                        setLoading(false)

                    }
                )
                break;
            }

            default: {
                setLoading(false)
            }
        }
    }
    const loadBalanceSheet = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `/account/balanceSheet/month/${selectedMonth.id}&${department.id}`
            );

            if (Array.isArray(response.data) && response.data.length > 0) {
                setBalanceSheet(response.data);
            } else {
                setBalanceSheet([]);
                notify("No balance sheet data found", "warn");
            }
        } catch (error) {
            setBalanceSheet([]);
            notify(error.message || "Failed to load balance sheet", "error");
        } finally {
            setLoading(false);
        }
    };
    const BalanceSheetReports = () => {
        const resetFilters = () => {
            setSelectedMonth({id: 1, month: "January"});
            setDepartment({id: 1, name: "ALL"});
            setBalanceSheet([]);
        };

        const summaryRow = useMemo(() => {
            if (!balanceSheet.length) return null;
            return balanceSheet.find((row) => row.month === "Summary") || balanceSheet[balanceSheet.length - 1];
        }, [balanceSheet]);

        const monthRows = useMemo(() => {
            return balanceSheet.filter((row) => row.month !== "Summary");
        }, [balanceSheet]);

        const amountBody = (field) => (rowData) => {
            const numericValue = numberFromFormatted(rowData[field]);
            const isNegative = numericValue < 0;

            return (
                <span className={isNegative ? "text-red-500 font-semibold" : ""}>
                {rowData[field]}
            </span>
            );
        };

        return (
            <>

                <div className="p-3">
                    <Card className="mb-3 ">
                        <div className="flex flex-column  justify-content-between align-items-start gap-3">
                            <div>
                                <h2 className="m-0 text-xl">Balance Sheet</h2>
                                <small className="text-color-secondary">
                                    User: {user} | Database: {database}
                                </small>
                            </div>

                            <div className="flex flex-column lg:flex-row gap-3 align-items-end">
                                <FloatLabel>
                                    <MonthSelect
                                        selectedMonth={selectedMonth}
                                        setSelectedMonth={setSelectedMonth}
                                        disable={false}
                                        id="balance-sheet-month"
                                    />
                                    <label htmlFor="balance-sheet-month">Month</label>
                                </FloatLabel>

                                <FloatLabel>
                                    <DepartmentSelect
                                        disable={false}
                                        department={department}
                                        setDepartment={setDepartment}
                                        departmentList={departmentList}
                                        id="balance-sheet-department"
                                    />
                                    <label htmlFor="balance-sheet-department">Department</label>
                                </FloatLabel>

                                <div className="flex gap-2">
                                    <Button
                                        label="Generate"
                                        icon="pi pi-check"
                                        onClick={loadBalanceSheet}
                                        loading={loading}
                                        size="small"
                                    />
                                    <Button
                                        label="Reset"
                                        icon="pi pi-refresh"
                                        severity="secondary"
                                        outlined
                                        onClick={resetFilters}
                                        disabled={loading}
                                        size="small"
                                    />
                                    <Button
                                        label="Print"
                                        icon="pi pi-print"
                                        severity="info"
                                        outlined
                                        onClick={printReport}
                                        disabled={!balanceSheet.length || loading}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    {!!summaryRow && (
                        <div className="grid mb-3">
                            <div className="col-12 md:col-4">
                                <Card title="Report Info">
                                    <div className="flex flex-column gap-2 text-sm">
                                        <div><strong>Company:</strong> {companyName}</div>
                                        <div><strong>Year:</strong> {projectYear}</div>
                                        <div><strong>Month:</strong> {selectedMonth.month}</div>
                                        <div><strong>Department:</strong> {department?.name || "ALL"}</div>
                                    </div>
                                </Card>
                            </div>

                            <div className="col-12 md:col-4">
                                <Card title="Profit Snapshot">
                                    <div className="flex flex-column gap-2 text-sm">
                                        <div><strong>Sale:</strong> {summaryRow.sale}</div>
                                        <div><strong>Cost of Sale:</strong> {summaryRow.saleCost}</div>
                                        <div><strong>Gross Profit:</strong> {summaryRow.gross}</div>
                                        <div><strong>Expenses:</strong> {summaryRow.expenses}</div>
                                        <div><strong>Net Profit:</strong> {summaryRow.net}</div>
                                    </div>
                                </Card>
                            </div>

                            <div className="col-12 md:col-4">
                                <Card title="Position Snapshot">
                                    <div className="flex flex-column gap-2 text-sm">
                                        <div><strong>Total Asset / Worth:</strong> {summaryRow.worth}</div>
                                        <div><strong>Opening Capital:</strong> {summaryRow.openingCapital}</div>
                                        <div><strong>Closing Capital:</strong> {summaryRow.closingCapital}</div>
                                        <div><strong>Drawings:</strong> {summaryRow.drawings}</div>
                                        <div><strong>Difference:</strong> {summaryRow.leftTotal}</div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    )}

                    {!!balanceSheet.length && (
                        <Card title="Balance Sheet Details">
                            <div ref={printRef}>
                                <div className="mb-3 text-center">
                                    <h2 className="m-0">{companyName}</h2>
                                    <div className="text-lg font-semibold">Balance Sheet</div>
                                    <div className="text-sm">
                                        Month: {selectedMonth.month} | Department: {department?.name || "ALL"} | Year: {projectYear}
                                    </div>
                                </div>

                                <DataTable
                                    value={balanceSheet}
                                    stripedRows
                                    showGridlines
                                    scrollable
                                    scrollHeight="70vh"
                                    size="small"
                                    tableStyle={{width: "100%"}}
                                    rowClassName={(rowData) => rowData.month === "Summary" ? "font-bold bg-primary-50" : ""}
                                >
                                    <Column field="month" header="Month" frozen style={{minWidth: "8rem"}}/>
                                    <Column field="opening" header="Opening Stock" body={amountBody("opening")} className="text-right" alignHeader="right"/>
                                    <Column field="closing" header="Closing Stock" body={amountBody("closing")} className="text-right" alignHeader="right"/>
                                    <Column field="purchase" header="Purchase" body={amountBody("purchase")} className="text-right" alignHeader="right"/>
                                    <Column field="saleCost" header="Cost of Sale" body={amountBody("saleCost")} className="text-right" alignHeader="right"/>
                                    <Column field="sale" header="Sale" body={amountBody("sale")} className="text-right" alignHeader="right"/>
                                    <Column field="gross" header="Gross Profit" body={amountBody("gross")} className="text-right" alignHeader="right"/>
                                    <Column field="expenses" header="Expenses" body={amountBody("expenses")} className="text-right" alignHeader="right"/>
                                    <Column field="net" header="Net Profit" body={amountBody("net")} className="text-right" alignHeader="right"/>
                                    <Column field="bank" header="Bank" body={amountBody("bank")} className="text-right" alignHeader="right"/>
                                    <Column field="cheque" header="Cheque in Hand" body={amountBody("cheque")} className="text-right" alignHeader="right"/>
                                    <Column field="cash" header="Cash in Hand" body={amountBody("cash")} className="text-right" alignHeader="right"/>
                                    <Column field="import" header="Import" body={amountBody("import")} className="text-right" alignHeader="right"/>
                                    <Column field="receivable" header="Receivable" body={amountBody("receivable")} className="text-right" alignHeader="right"/>
                                    <Column field="payable" header="Payable" body={amountBody("payable")} className="text-right" alignHeader="right"/>
                                    <Column field="asset" header="Asset" body={amountBody("asset")} className="text-right" alignHeader="right"/>
                                    <Column field="worth" header="Worth" body={amountBody("worth")} className="text-right" alignHeader="right"/>
                                    <Column field="drawings" header="Drawings" body={amountBody("drawings")} className="text-right" alignHeader="right"/>
                                    <Column field="openingCapital" header="Opening Capital" body={amountBody("openingCapital")} className="text-right" alignHeader="right"/>
                                    <Column field="gains" header="Gains" body={amountBody("gains")} className="text-right" alignHeader="right"/>
                                    <Column field="closingCapital" header="Closing Capital" body={amountBody("closingCapital")} className="text-right" alignHeader="right"/>
                                    <Column field="leftTotal" header="Difference" body={amountBody("leftTotal")} className="text-right" alignHeader="right"/>
                                </DataTable>

                                {!!monthRows.length && (
                                    <div className="mt-4">
                                        <h3>Monthly Rows Only</h3>
                                        <DataTable
                                            value={monthRows}
                                            stripedRows
                                            showGridlines
                                            size="small"
                                            tableStyle={{minWidth: "80rem"}}
                                        >
                                            <Column field="month" header="Month"/>
                                            <Column field="sale" header="Sale" className="text-right" alignHeader="right"/>
                                            <Column field="gross" header="Gross" className="text-right" alignHeader="right"/>
                                            <Column field="expenses" header="Expenses" className="text-right" alignHeader="right"/>
                                            <Column field="net" header="Net" className="text-right" alignHeader="right"/>
                                            <Column field="worth" header="Worth" className="text-right" alignHeader="right"/>
                                            <Column field="closingCapital" header="Closing Capital" className="text-right" alignHeader="right"/>
                                        </DataTable>
                                    </div>
                                )}
                            </div>
                        </Card>
                    )}
                </div>
            </>
        );
    }
    const OptionSelect = () => {
        return (
            <div className="card shadow-2 p-3 mb-4 border-round-xl bg-surface-0">
                <div className="flex flex-column lg:flex-row justify-content-between align-items-center gap-4">

                    {/* Action Buttons Group */}
                    <div
                        className="flex flex-row gap-2 w-full lg:w-auto justify-content-center lg:justify-content-start">
                        <Button
                            label="Proceed"
                            icon="pi pi-check-circle"
                            severity="success"
                            className="p-button-raised"
                            onClick={() => applyAction()}
                            disabled={((selectedMonth === 0) && (action === "Profit&Loss" || action === "BalanceSheet")) || (action === "Closing" && !projectName)}
                        />
                        <Button
                            label="Reset"
                            icon="pi pi-refresh"
                            severity="secondary"
                            outlined
                            onClick={() => resetPage()}
                        />
                        <Button
                            icon="pi pi-print"
                            severity="info"
                            text
                            raised
                            onClick={() => handlePrintOptions()}
                            disabled={loading || (action === "Profit&Loss" && pr.length === 0) || (action === "BalanceSheet") || (action === "CleanAccount" && !projectName)}
                        />
                    </div>

                    {/* Radio Options Group */}
                    <div
                        className="flex flex-wrap justify-content-center lg:justify-content-end gap-3 px-3 py-2 border-1 border-300 border-round-lg bg-gray-50">
                        {[
                            {id: 'pl', val: 'Profit&Loss', lab: 'PROFIT & LOSS', auth: level.all()},
                            {id: 'bs', val: 'BalanceSheet', lab: 'BALANCE SHEET', auth: level.all()},
                            {id: 'bs1', val: 'BalanceSheetReport', lab: 'BALANCE SHEET REPORT', auth: level.all()},
                            {id: 'cl', val: 'Closing', lab: 'CLOSING', auth: level.all()},
                            {id: 'ca', val: 'CleanAccount', lab: 'CLEAN', auth: level.all() || level.cashier()},
                            {id: 'db', val: 'Debug', lab: 'DEBUG', auth: level.all() || level.cashier()}
                        ].map((opt) => (
                            <div key={opt.id} className="flex align-items-center">
                                <RadioButton
                                    inputId={opt.id}
                                    name="action"
                                    value={opt.val}
                                    onChange={(e) => setAction(e.value)}
                                    checked={action === opt.val}
                                    disabled={!opt.auth}
                                />
                                <label htmlFor={opt.id}
                                       className="ml-2 text-sm font-semibold cursor-pointer uppercase text-700">
                                    {opt.lab}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };
    const OptionMonthSelect = () => {
        return (
            <>
                <div
                    className="card container flex-row  shadow-7 border-round-md justify-content-center flex  w-fit p-2 ">
                    <FloatLabel>
                        <MonthSelect selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} id={"mn"}
                                     disable={false}/>
                        <label htmlFor="mn">Month</label>
                    </FloatLabel>
                    <FloatLabel>
                        <DepartmentSelect disable={false} department={department} setDepartment={setDepartment}
                                          departmentList={departmentList.filter(it => it.name.trim() !== "NONE")}
                                          id={"dp"}/>
                        <label htmlFor="dp">Department</label>
                    </FloatLabel>

                </div>
            </>
        )
    }
    const OptionProjectSelect = () => {
        const [cleanedValue, setCleanedValue] = useState(projectName)
        const sanityCheck = (e) => {
            setCleanedValue(e.replace(/[^a-zA-Z0-9]/g, '').substring(0, 20))
        }
        const lostFocus = () => {
            setProjectValue(cleanedValue)
            setProjectName(cleanedValue)

        }
        return (
            <div
                className="container shadow-7 border-round-md justify-content-start flex flex-column lg:flex-row lg:justify-content-between">
                <div className="flex w-fit ">
                    <FloatLabel className={"p-2"}>
                        <InputText
                            disabled={false}
                            onChange={(e) => sanityCheck(e.target.value)}
                            value={cleanedValue}
                            className={"h-2rem"}
                            id="pn"
                            onBlur={lostFocus} // Pass the reference directly
                        />
                        <label htmlFor="pn">New Project Name</label>
                    </FloatLabel>
                    <FloatLabel className={"p-2"}>
                        <InputNumber
                            disabled={false}
                            onValueChange={(e) => setProjectYear(e.value)} // PrimeReact InputNumber returns an object
                            value={projectYear}
                            className={"h-2rem"}
                            id="py"
                            showButtons={false}
                            useGrouping={false} // Often desired for years so you don't get "2,024"
                        />
                        <label htmlFor="py">New Project Year</label>
                    </FloatLabel>
                </div>
            </div>
        );
    }


    const ShowInventory = () => {
        const [showImage, setShowImage] = useState(false)
        const [mode, setMode] = useState("")
        const [invoiceId, setInvoiceId] = useState(0)
        const inventoryHeader = () => {
            return (
                <div className="flex justify-content-end">
                    <Button icon="pi pi-print" className="mr-1 pr-2"
                            onClick={() => InventoryPrint(inventory, bioData.name, item, "All")}
                            disabled={inventory.length === 0}/>
                </div>
            );
        };
        const handleTableClick = (data) => {
            setMode(data.data.mode)
            setInvoiceId(data.data.invoiceId)
            if (data.data.invoiceId > 0) {
                setShowImage(true)
            }

        }
        if (inventory.length === 0) {
            return (
                <div className="card">
                    <div className="flex flex-row justify-content-center">
                        <h1>No Inventory Found</h1>
                    </div>
                </div>
            )
        } else if (showImage) {
            return (
                <>
                    {showImage ? <ViewImages invoice={invoiceId} mode={mode} showImage={showImage}
                                             setShowImage={setShowImage}/> : null}

                </>
            )
        } else {
            return (
                <>
                    <div className="card h-full">
                        <DataTable value={inventory} size="small" tableStyle={{minWidth: '50rem'}} showGridlines
                                   stripedRows onRowClick={(e) => handleTableClick(e)}
                                   paginator rows={25} scrollable scrollHeight="80vh" header={inventoryHeader}>
                            <Column className="text-left text-xs md:text-base" field="date" header="Date"
                                    style={{width: "fit-content"}}/>
                            <Column className="text-left text-xs md:text-base" field="invoiceId" header="Folio"
                                    style={{width: "fit-content"}}></Column>
                            <Column className="text-left text-xs md:text-base" field="mode" header="Mode"
                                    style={{width: "fit-content"}}></Column>
                            <Column className="text-end text-xs md:text-base" field="sold" header="Sold"
                                    alignHeader="right" style={{width: "fit-content"}}></Column>
                            <Column className="text-end text-xs md:text-base" field="purchase" header="Bought"
                                    alignHeader="right" style={{width: "fit-content"}}></Column>
                            <Column className="text-end text-xs md:text-base" field="price" header="Price"
                                    alignHeader="right" style={{width: "fit-content"}}></Column>
                            <Column className="text-left text-xs md:text-base" field="balance" header="Balance"
                                    style={{width: "fit-content"}}></Column>
                            <Column className="text-left text-xs md:text-base" field="comment" header="Comment"
                                    style={{width: "fit-content"}}></Column>
                        </DataTable>

                    </div>
                </>
            )
        }

    }
    useEffect(() => {
        setBalanceSheet([])
        setPr([])
        setDebugReport([])
        setInventory([])
    }, [action])


    const ShowBalanceSheet = () => {
        if (balanceSheet.length > 0 && !loading) {
            const contentRef = useRef(null);
            const reactToPrintFn = useReactToPrint(
                {
                    contentRef: contentRef,
                    pageStyle: "@page { size: landscape; }",
                    documentTitle: `BalanceSheet-${selectedMonth.month}-${selectedMonth.year}`,
                });
            return (
                <div className="container  m-4 flex flex-column w-fit justify-content-center align-items-start">
                    <Button className={"w-1"} icon={"pi pi-print"} onClick={reactToPrintFn}/>
                    <div ref={contentRef}>
                        {balanceSheet.map((rowItem) => {
                            const itemKey = rowItem.id || `bs-${rowItem.month}`;
                            return (
                                <React.Fragment key={itemKey}>
                                    <div className="page-break"/>
                                    <BalanceSheetTemplate bs={rowItem}/>
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            );

        }
    };


    const ShowPNL = () => {
        const [selectedProduct, setSelectedProduct] = useState(null);

        useEffect(() => {
            if (selectedProduct) {
                const itemId = pr.find((b) => b.item.trim() === selectedProduct.item.trim()).itemId
                setItem(selectedProduct.item)
                loadInventory(itemId)
            }
        }, [selectedProduct])

        // ✅ Move all rows with profit like "(123)" to the END
        const profitStartsWithParen = (row) => String(row?.profit ?? "").trim().startsWith("-");

        const prOrdered = React.useMemo(() => {
            const normal = [];
            const parenProfit = [];
            for (const row of pr) {
                ( normal).push(row);
            }
            return [...normal, ...parenProfit];
        }, [pr]);

        if (!loading && pr.length > 0) {
            return (
                <>
                    <div className="container card m-4 mx-auto ">
                        <DataTable
                            value={prOrdered}
                            stripedRows
                            scrollable
                            scrollHeight="80vh"
                            tableStyle={{minWidth: '50rem'}}
                            resizableColumns
                            size={"small"}
                            selectionMode="single"
                            selection={selectedProduct}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            dataKey="id"
                            rowClassName={(rowData) => (profitStartsWithParen(rowData) ? "pnl-loss-row" : "")}
                        >
                            <Column className="text-left text-xs md:text-small"
                                    style={{width: "fit-content", height: "5px"}} field="date"
                                    header="Date" alignHeader="left" headerStyle={{width: "fit-content"}}/>
                            <Column className="text-left text-xs md:text-small" style={{width: "fit-content"}}
                                    field="invoice"
                                    header="Folio" alignHeader="left" headerStyle={{width: "fit-content"}}/>
                            {isDesktop &&
                                <Column className="text-left text-xs md:text-small" style={{width: "fit-content"}}
                                        field="customer"
                                        header="Customer " alignHeader="left"></Column>}
                            <Column className="text-left text-xs md:text-small" style={{width: "fit-content"}}
                                    field="item"
                                    header="Item " alignHeader="left"/>
                            {isDesktop &&
                                <Column className="text-right text-xs md:text-small" style={{width: "fit-content"}}
                                        field="quantity"
                                        header="Quantity" alignHeader="right"></Column>}
                            {isDesktop &&
                                <Column className="text-right text-xs md:text-small" style={{width: "fit-content"}}
                                        field="price"
                                        header="Price" alignHeader="right"></Column>}
                            {isDesktop &&
                                <Column className="text-right text-xs md:text-small" style={{width: "fit-content"}}
                                        field="cost"
                                        header="Cost" alignHeader="right"></Column>}
                            <Column className="text-right text-xs md:text-small" style={{width: "fit-content"}}
                                    field="profit"
                                    header="Profit" alignHeader="right"></Column>
                            <Column className="text-right text-xs md:text-small" style={{width: "fit-content"}}
                                    field="total"
                                    header="Total" alignHeader="right"></Column>
                        </DataTable>
                    </div>
                </>
            )
        }
    }

    const ShowDebug = () => {
        if (!loading && debugReport.length > 0) {
            return (
                <>
                    <div className="card">
                        <DataTable value={debugReport} scrollable stripedRows scrollHeight="80vh"
                                   tableStyle={{minWidth: '50rem', height: '100%', width: '100vw'}} resizableColumns
                                   showGridlines columnResizeMode="expand"
                                   paginator rows={15}>
                            <Column className="text-left text-xs md:text-small" style={{width: 'auto'}} field="id"
                                    header="Folio"></Column>
                            <Column className="text-left text-xs md:text-small" style={{width: 'auto'}} field="mode"
                                    header="Transaction" alignHeader="left"></Column>
                            <Column className="text-left text-xs md:text-small" style={{width: 'auto'}} field="content"
                                    header="Details" alignHeader="left"></Column>

                        </DataTable>
                    </div>
                </>
            )
        }
    }
    const InventoryContent = () => {
        return (
            <div className="flex flex-nowrap flex-shrink-1 justify-content-start align-content-start">
                <div className="card flex justify-content-center">
                    <Sidebar visible={showInventory} onHide={() => setShowInventory(false)} position="right"
                             className="w-10">
                        <ShowInventory/>
                    </Sidebar>
                </div>
            </div>
        )
    }
    if (!loading) {
        return (
            <>
                <ToastContainer/>
                <MunshiMenu handle={handle}/>
                {showInventory && <InventoryContent/>}
                <div className="flex flex-column justify-content-start   h-auto w-full ml-2 mr-2">
                    <div className="flex flex-column">
                        <OptionSelect/>
                        {(action === "Profit&Loss" || action === "BalanceSheet") && <OptionMonthSelect/>}
                        {action === "Closing" && <OptionProjectSelect/>}
                    </div>
                    <div className="flex flex-row justify-content-start w-full">
                        {action === "Profit&Loss" &&
                            <div className="flex flex-row justify-content-start w-full mr-2 ml-2">
                                <ShowPNL/></div>}
                        {action === "BalanceSheet" &&
                            <div className="flex flex-row justify-content-start w-100">
                                <ShowBalanceSheet/>
                            </div>}
                        {action === "BalanceSheetReport" &&
                            <div className="flex flex-row justify-content-start w-100">
                                <BalanceSheetReports/>
                            </div>}

                        {action === "Debug" &&
                            <div className="flex flex-row justify-content-start w-100"><ShowDebug/>
                            </div>}
                    </div>

                </div>
            </>
        )
    }


}

export default SummeryAccount;
